module.exports = __webpack_public_path__ + "img/art.890f2809.png";